import styled from "styled-components";

import { QUERIES, SPACING } from "../../../../../utils/constants";
import { LegendStyle } from "./types";

export const TrendsCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  padding: ${SPACING.md}px;
  min-width: 0;
  background: var(--color-card-background);
  border: 1px solid var(--color-card-border);
  border-radius: 16px;
  box-shadow: var(--shadow-small);

  @media ${QUERIES.tabletLargeAndUp} {
    padding: ${SPACING.lg}px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;

  @media ${QUERIES.laptopAndUp} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xxl);
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 1.1;
  color: var(--color-text-default);
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: var(--text-sm);
  font-style: italic;
  color: var(--color-text-secondary);

  @media ${QUERIES.laptopAndUp} {
    font-size: var(--text-base);
  }
`;

export const ChartArea = styled.div`
  width: 100%;
`;

export const EmptyMessage = styled.p`
  margin: 0;
  padding: ${SPACING.xxl}px ${SPACING.md}px;
  text-align: center;
  color: var(--color-text-secondary);
  font-size: var(--text-md);
`;

export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${SPACING.lg}px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  font-size: var(--text-base);
  color: var(--color-text-secondary);
`;

export const LegendSwatch = styled.span<{
  $color: string;
  $style: LegendStyle;
}>`
  flex-shrink: 0;
  width: ${({ $style }) => ($style === "dot" ? "10px" : "22px")};
  height: ${({ $style }) => ($style === "dot" ? "10px" : "0")};
  border-radius: ${({ $style }) => ($style === "dot" ? "50%" : "3px")};
  background: ${({ $style, $color }) =>
    $style === "dot" ? $color : "transparent"};
  border-top: ${({ $style, $color }) =>
    $style === "dot" ? "none" : `3px solid ${$color}`};
`;

export const HelperNote = styled.span`
  font-size: var(--text-sm);
  font-style: italic;
  color: var(--color-text-secondary);
`;

export const DesktopControl = styled.div`
  display: none;

  @media ${QUERIES.laptopAndUp} {
    display: block;
  }
`;

export const MobileControl = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${SPACING.sm}px;

  @media ${QUERIES.laptopAndUp} {
    display: none;
  }
`;
